<app-home-custom-top-header *ngIf="isUserLoggedIn"></app-home-custom-top-header>
<app-comman-header *ngIf="isUserLoggedIn"></app-comman-header>
<app-pricing-details-header></app-pricing-details-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <app-pricing-details-data></app-pricing-details-data>
                </div>
            </div>
        </div>
    </div>
</div>
